export default function CrystalsActive({ width = 22, height = 24, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 22 24"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M18.374 1L20.9121 6.27246L17.5615 15.1377L11 22.3477L4.4375 15.1377L1.08691 6.27246L3.62598 1H18.374Z"
                fill="#EAEAEA"
                stroke="#EAEAEA"
                strokeWidth="2"
            />
        </svg>
    );
}
